angular.module('importPercent.components', [])
    .component('importPercent', {
        templateUrl: 'ng/components/importPercent/importPercent.view.html',
        bindings: {
            import: '<',
            formName: '=',
            change: '&',
            inputClass: '@',
            inputName: '@',
            value: '<',
            perc: '<',
            inputDisabled: '<',
            tabIndex: "@",
            snapshot: '<',
            preservePercent: '<'

        },
        controllerAs: 'impPercCtrl',
        controller: ImportPercentController
    });

function ImportPercentController() {

    var self = this;

    self.$onInit = function () {
        self.formName = self.formName || "currencyForm"
        self.currencyValue = self.value;
        self.percentValue = self.perc;
        if (!self.snapshot) {
            if (self.preservePercent) {
                self.isChanged('percent-' + self.inputName, self.percentValue);
            } else {
                self.isChanged('currency-' + self.inputName, self.currencyValue);
            }
            if (self.formName.$name == "formVendorPaymentDetail") {
                //self.isChanged('percent-' + self.inputName, self.percentValue);
            }
        }
        if (typeof self.tabIndex != "undefinend") {
            self.tabUno = parseInt(self.tabIndex);
            self.tabDue = self.tabUno + 1;
        }
    }

    var init = function () {
        self.formName = self.formName || "currencyForm"
    }

    self.$onChanges = function (changes) {

        if (changes.formName && changes.formName.currentValue && !self.snapshot) {
            init();
        }

        if (changes.import && changes.import.currentValue && !self.snapshot) {
            init();
        }
        if (changes.value && typeof changes.value.currentValue != 'undefined' && !self.snapshot) {
            var tempCurrentValue = changes.value.currentValue;
            var tempPreviousValue = changes.value.previousValue;
            if (tempCurrentValue == self.currencyValue) {
                return
            }
            if (!isNaN(tempCurrentValue) && !isNaN(tempPreviousValue) && tempCurrentValue != tempPreviousValue) {
                self.isChanged('currency-' + self.inputName, changes.value.currentValue);
            }

        }
        if (changes.perc && typeof changes.perc.currentValue != 'undefined' && !self.snapshot) {
            var tempCurrentValue = changes.perc.currentValue;
            var tempPreviousValue = changes.perc.previousValue;
            if (tempCurrentValue == self.percentValue) {
                return
            }
            if (!isNaN(tempCurrentValue) && !isNaN(tempPreviousValue) && tempCurrentValue != tempPreviousValue) {
                self.isChanged('percent-' + self.inputName, changes.perc.currentValue);
            }
        }
    }

    self.isChanged = function (name, value) {
        value = parseFloat(value || 0);
        if (isNaN(value) || value < 0) {
            return
        }
        switch (name) {
            case 'currency-' + self.inputName:
                if (value <= self.import) {
                    const tempCurrency = Math.round(((self.import * self.percentValue) / 100) * 100) / 100;
                    if (tempCurrency != value || value != self.currencyValue) {
                        self.percentValue = Math.round(((value * 100) / self.import) * 10000) / 10000;
                        self.currencyValue = value;
                    }
                } else {
                    self.percentValue = 0;
                    self.currencyValue = 0;
                }
                break;

            case 'percent-' + self.inputName:
                if (value <= 100) {
                    const tempPercent = Math.round(((self.currencyValue * 100) / self.import) * 10000) / 10000
                    if (tempPercent != value || value != self.percentValue) {
                        self.currencyValue = Math.round(((self.import * value) / 100) * 100) / 100;
                        self.percentValue = value;
                    }
                } else {
                    self.percentValue = 0;
                    self.currencyValue = 0;
                }

                break;
            default:
                break;
        }
        if (isNaN(self.percentValue) || typeof self.percentValue == "undefined") {
            self.percentValue = 0;
        }
        self.change({
            currency: Math.round(self.currencyValue * 10000) / 10000,
            percent: self.percentValue
        })

    }


}